import { Subject } from '../Subject';
import { multicast } from './multicast';
import { connect } from './connect';
export function publish(selector) {
    return selector ? function (source) { return connect(selector)(source); } : function (source) { return multicast(new Subject())(source); };
}
//# sourceMappingURL=publish.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/operators/publish.js
// module id = 1241
// module chunks = 0